module.exports = __webpack_public_path__ + "img/avatar-support.d7b92d3e.svg";